"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "24",
    height: " 24",
    fill: "#004864"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M.15,23.85a.52.52,0,0,0,.59.1l5.47-2.74L2.79,17.79.05,23.26A.52.52,0,0,0,.15,23.85Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M22.16,5.46l1.09-1.09A2.56,2.56,0,1,0,19.63.75L18.54,1.84Z"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "2.24",
    y: "9.01",
    width: "20.37",
    height: "5.12",
    transform: "translate(-4.55 12.18) rotate(-45)"
  }));
};

exports["default"] = _default;